import React from 'react';
import { ArrowForward } from '@yme/assets/icons';
import { Button, GHOST_VARIANT, SIZE_36, TRAILING_ICON } from '@yme/atoms/button';
import { LinkStyled } from '@yme/molecules/buttons/styled';
export function ViewAllButton({ linkTo, isRightToLeft, viewAllLabel }) {
    return (React.createElement(LinkStyled, { to: linkTo },
        React.createElement(Button, { as: "span", buttonVariant: GHOST_VARIANT, hasIconButton: TRAILING_ICON, iconComponent: ArrowForward, isRightToLeft: isRightToLeft, size: SIZE_36, label: viewAllLabel })));
}
